import { render } from "./NewSidebar.vue?vue&type=template&id=c07e33de&scoped=true"
import script from "./NewSidebar.vue?vue&type=script&lang=js"
export * from "./NewSidebar.vue?vue&type=script&lang=js"

import "./NewSidebar.vue?vue&type=style&index=0&id=c07e33de&scoped=true&lang=css"

import exportComponent from "/var/www/zaytoon-frontend-base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c07e33de"]])

export default __exports__